import React, { useState, useEffect } from 'react';
import { onAuthChange, getCurrentUser } from '../firebase/auth';
import { getDocumentById, updateDocument } from '../firebase/firestore';
import AuthContext from './AuthContext';

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [userProfile, setUserProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const unsubscribe = onAuthChange(async (authUser) => {
            try {
                if (authUser) {
                    setUser(authUser);
                    // Fetch user profile from Firestore
                    const profile = await getDocumentById('users', authUser.uid);
                    setUserProfile(profile);
                } else {
                    setUser(null);
                    setUserProfile(null);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        });
        return () => unsubscribe();
    }, []);

    // ==================== THIS IS THE NEW FUNCTION ====================
    const updateUserProfile = async (updates) => {
        if (!user?.uid) {
            throw new Error('No user logged in');
        }

        try {
            console.log('🔄 Updating user profile:', updates);

            // Update in Firestore
            await updateDocument('users', user.uid, {
                ...updates,
                updatedAt: new Date(),
            });

            console.log('✅ User profile updated in Firestore');

            // Update local state
            setUserProfile((prev) => ({
                ...prev,
                ...updates,
            }));

            console.log('✅ Local state updated');
            return true;
        } catch (err) {
            console.error('❌ Error updating user profile:', err);
            throw new Error(`Failed to update profile: ${err.message}`);
        }
    };

    const value = {
        user,
        userProfile,
        loading,
        error,
        updateUserProfile, // ← ADD THIS
        isAdmin: userProfile?.role === 'admin',
        isStudent: userProfile?.role === 'student',
        isStartup: userProfile?.role === 'startup',
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
